const CHANGE_ShortsMaker_INPUT_FIELD = 'CHANGE_ShortsMaker_INPUT_FIELD';
const CHANGE_VIDEO_COMPRESSOR_INPUT_FIELD =
	'CHANGE_VIDEO_COMPRESSOR_INPUT_FIELD';
export { CHANGE_ShortsMaker_INPUT_FIELD, CHANGE_VIDEO_COMPRESSOR_INPUT_FIELD };
